import {Component, OnInit} from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ContactSalesComponent} from '../home-old/home-old.component';
import {MatDialog} from '@angular/material';

@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.css']
})


export class PlansComponent implements OnInit {

    featureList: any [];
    plansList: any [];
    items: any;
    columns: any;
    orderedData = [];
    displayedColumns: string[] = ['displayName', 'community', 'starter', 'business', 'enterprise'];
    headerColumn = ['Community', 'Starter', 'Business', 'Enterprise'];
    constructor(public dialog: MatDialog, private _service: ConnecttocrudService) {
    }

    ngOnInit() {
        this._service.getFeatures().subscribe(data => {
            this.featureList = data;
            const arrayList = [];
            const groupBy = function (xs, key) {
                return xs.reduce(function (rv: any[], x) {
                    const columnValue = {};
                    columnValue[x.category] = x;
                    (rv[x[key]] = rv[x[key]] || []).push(x);
                    return rv;
                }, {});
            };
            this.columns = groupBy(data, 'category');
            this.orderedData = Object.keys(this.columns).map(key => ({type: key, value: this.columns[key]}));

        });

        this._service.getPlans().subscribe(data => {
            this.plansList = data;
        });
    }

    getStatus(val) {
        let result = false;
        if (val == 'Available') {
            result = true;
        } else if (val == 'Not Available') {
            result = true;
        } else {
            result = false;
        }
        return result;
    }

    openDialog() {
        const dialogRef = this.dialog.open(ContactSalesComponent, {
            data: '',
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(result => {
            // this.accept = result;
        });
    }
}
